// src/components/documentos/TemplateCard.jsx

import React from "react";
import { Check, Pencil, Eye, Trash2 } from "lucide-react";
import { MOCK_DATA as TechBlueMock } from "../../templates/cotizacion/TechBlue";

// Mock data por plantilla para el preview del card
// Cuando agregues más plantillas, importa su MOCK_DATA aquí
const MOCK_BY_ID = {
  "cotizacion-tech-blue": TechBlueMock,
  // "cotizacion-corporativa": CorporativaMock,
  // "factura-moderna": FacturaModernaMock,
};

export default function TemplateCard({
  template,
  isActive,
  onSelect,
  onEdit,
  onPreview,
  onDelete,
}) {
  const TemplateComponent = template.component;
  const mockData = MOCK_BY_ID[template.id];

  return (
    <div
      className={`tpl-card tpl-card--group ${isActive ? "tpl-card--active" : ""}`}
    >
      {/* ── Badge ACTIVA ── */}
      {isActive && (
        <div className="tpl-card__badge">
          <Check size={11} strokeWidth={3} />
          ACTIVA
        </div>
      )}

      {/* ── Preview ── */}
      <div className="tpl-card__preview">
        {TemplateComponent && mockData ? (
          /* Componente real escalado al ~22% */
          <div className="tpl-card__scale-wrapper">
            <div className="tpl-card__scale-inner">
              <TemplateComponent data={mockData} />
            </div>
          </div>
        ) : (
          /* Fallback SVG para plantillas sin componente aún */
          <TemplatePlaceholder templateId={template.id} />
        )}

        {/* Overlay "Ampliar Vista" — solo en hover */}
        <div className="tpl-card__overlay">
          <button
            className="tpl-card__preview-btn"
            onClick={() => onPreview(template.id)}
          >
            <Eye size={16} />
            Ampliar Vista
          </button>
        </div>
      </div>

      {/* ── Footer ── */}
      <div className="tpl-card__footer">
        <span className="tpl-card__name">{template.name}</span>
        <div className="tpl-card__actions">
          {isActive ? (
            <span className="tpl-card__selected">
              <Check size={13} strokeWidth={2.5} />
              Seleccionada
            </span>
          ) : (
            <button
              className="tpl-card__btn tpl-card__btn--primary"
              onClick={() => onSelect(template.id)}
            >
              Usar esta plantilla
            </button>
          )}

          {/* Botones icono agrupados */}
          <div style={{ display: "flex" }}>
            <button
              className="tpl-card__btn tpl-card__btn--icon"
              onClick={() => onEdit(template.id)}
              title="Editar plantilla"
            >
              <Pencil size={14} />
            </button>
            <button
              className={`tpl-card__btn tpl-card__btn--icon ${isActive ? "tpl-card__btn--icon-disabled" : ""}`}
              onClick={() => !isActive && onDelete?.(template.id)}
              title="Eliminar plantilla"
              disabled={isActive}
            >
              <Trash2 size={14} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Fallback SVG (plantillas sin componente todavía) ─────────────────────────
const PLACEHOLDER_THEMES = {
  "cotizacion-tech-blue": { header: "#1e3a5f", accent: "#3b82f6" },
  "cotizacion-corporativa": { header: "#1f2937", accent: "#6366f1" },
  "cotizacion-minimalista": { header: "#111827", accent: "#374151" },
  "factura-moderna": { header: "#065f46", accent: "#10b981" },
  "factura-clasica": { header: "#78350f", accent: "#d97706" },
  "remision-estandar": { header: "#1e3a5f", accent: "#0ea5e9" },
  "orden-compra-formal": { header: "#4c1d95", accent: "#8b5cf6" },
};

function TemplatePlaceholder({ templateId }) {
  const { header, accent } = PLACEHOLDER_THEMES[templateId] || {
    header: "#1e3a5f",
    accent: "#3b82f6",
  };
  return (
    <svg
      viewBox="0 0 200 260"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "75%", maxHeight: "185px", borderRadius: 6 }}
    >
      <rect width="200" height="260" fill="#f8fafc" />
      <rect width="200" height="52" fill={header} />
      <rect
        x="12"
        y="14"
        width="40"
        height="10"
        rx="2"
        fill="rgba(255,255,255,0.3)"
      />
      <rect
        x="12"
        y="28"
        width="26"
        height="6"
        rx="2"
        fill="rgba(255,255,255,0.15)"
      />
      <rect x="134" y="18" width="54" height="16" rx="8" fill={accent} />
      <rect
        x="142"
        y="23"
        width="38"
        height="5"
        rx="2"
        fill="rgba(255,255,255,0.7)"
      />
      <rect x="12" y="62" width="50" height="5" rx="2" fill={accent} />
      <rect x="12" y="72" width="80" height="4" rx="2" fill="#cbd5e1" />
      <rect x="12" y="80" width="60" height="4" rx="2" fill="#e2e8f0" />
      <rect x="12" y="102" width="176" height="14" rx="3" fill={header} />
      <rect
        x="16"
        y="106"
        width="30"
        height="5"
        rx="2"
        fill="rgba(255,255,255,0.4)"
      />
      <rect
        x="90"
        y="106"
        width="30"
        height="5"
        rx="2"
        fill="rgba(255,255,255,0.4)"
      />
      <rect
        x="148"
        y="106"
        width="30"
        height="5"
        rx="2"
        fill="rgba(255,255,255,0.4)"
      />
      {[0, 1, 2, 3].map((i) => (
        <g key={i}>
          <rect
            x="12"
            y={120 + i * 14}
            width="176"
            height="12"
            rx="2"
            fill={i % 2 === 0 ? "#f1f5f9" : "#fff"}
          />
          <rect
            x="16"
            y={124 + i * 14}
            width="40"
            height="4"
            rx="2"
            fill="#cbd5e1"
          />
          <rect
            x="90"
            y={124 + i * 14}
            width="20"
            height="4"
            rx="2"
            fill="#e2e8f0"
          />
          <rect
            x="152"
            y={124 + i * 14}
            width="28"
            height="4"
            rx="2"
            fill="#94a3b8"
          />
        </g>
      ))}
      <rect x="100" y="182" width="88" height="20" rx="3" fill={header} />
      <rect
        x="106"
        y="187"
        width="34"
        height="5"
        rx="2"
        fill="rgba(255,255,255,0.4)"
      />
      <rect
        x="148"
        y="187"
        width="34"
        height="6"
        rx="2"
        fill="rgba(255,255,255,0.85)"
      />
      <rect x="12" y="218" width="176" height="1" fill="#e2e8f0" />
      <rect x="12" y="224" width="80" height="4" rx="2" fill="#e2e8f0" />
      <rect x="120" y="224" width="68" height="4" rx="2" fill="#e2e8f0" />
    </svg>
  );
}
